// material
import { Box } from '@mui/material';
import { useBranding } from 'src/contexts/BrandContext';

// ----------------------------------------------------------------------

export default function Logo({ ...other }) {
  const branding = useBranding();
  return (
    <Box
      component="img"
      alt={branding?.displayName || 'logo'}
      src={branding?.logoUrl || '/static/brand/careit_text.svg'}
      height={40}
      {...other}
    />
  );
}
